import DashboardAPI from '~/api/dashboardApi';
import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function UserLocationMap({ registerUsersLocation = [] }) {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        async function fetchLocations() {
            const mappedLocation = [];

            for (const userLocation of registerUsersLocation) {
                try {
                    const geoRes = await fetch(
                        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
                            userLocation.Location
                        )}&format=json&limit=1`
                    );
                    const data = await geoRes.json();

                    if (data && data.length > 0) {
                        mappedLocation.push({
                            address: userLocation.Location,
                            lat: parseFloat(data[0].lat),
                            lon: parseFloat(data[0].lon),
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            }

            setLocations(mappedLocation);
        }

        if (registerUsersLocation.length > 0) {
            fetchLocations();
        }
    }, [registerUsersLocation]);

    return (
        <div className="w-100" style={{ height: "435px" }}>
            <MapContainer className="w-100 h-100 rounded-2" center={[16.0471, 108.2068]} zoom={5}>
                <TileLayer
                    attribution='&copy; <a href="https://cartodb.com/attributions">CARTO</a>'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                />
                {locations.map((location, index) => (
                    <Marker key={index} position={[location.lat, location.lon]}>
                        <Popup>
                            <b>{location.address}</b>
                            <br />
                            {location.address}
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
}

export default UserLocationMap;
